import TransactionTable from "./transactions-table"

const Transactions = ({data}: any) => {
    return (
        <div>
            <TransactionTable data={data}/>
        </div>
    )
}


export default Transactions